import { render, staticRenderFns } from "./CheckVersionModal.vue?vue&type=template&id=5fb06090&scoped=true"
import script from "./CheckVersionModal.vue?vue&type=script&lang=js"
export * from "./CheckVersionModal.vue?vue&type=script&lang=js"
import style0 from "./CheckVersionModal.vue?vue&type=style&index=0&id=5fb06090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb06090",
  null
  
)

export default component.exports